import { render } from "./IconChevronRight.vue?vue&type=template&id=4083f58a&ts=true"
import script from "./IconChevronRight.vue?vue&type=script&lang=ts"
export * from "./IconChevronRight.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__